import { render, staticRenderFns } from "./I18n.vue?vue&type=template&id=1de09e50&scoped=true"
import script from "./I18n.vue?vue&type=script&lang=js"
export * from "./I18n.vue?vue&type=script&lang=js"
import style0 from "./I18n.vue?vue&type=style&index=0&id=1de09e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de09e50",
  null
  
)

export default component.exports